import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

export type AIAuthContextValue = {
  getAccessToken: () => Promise<string | undefined>;
  user: { id: string; username: string; firstName?: string } | undefined;
  standort: { id: string; name: string };
};

const AIAuthContext = createContext<AIAuthContextValue | undefined>(undefined);

export function AIAuthProvider({
  value,
  children,
}: {
  value: AIAuthContextValue;
  children: ReactNode;
}) {
  return (
    <AIAuthContext.Provider value={value}>{children}</AIAuthContext.Provider>
  );
}

// oxlint-disable-next-line react/only-export-components
export function useAIAuth(): AIAuthContextValue {
  const context = useContext(AIAuthContext);

  if (context === undefined) {
    throw new Error('useAIAuth must be used within an AIAuthProvider');
  }

  return context;
}
